// Functional Imports
import { useContext } from 'react';
import ErrorModalContext from '../../../../context/error-modal-context/error-modal-context';

// Components Import
import PopupListBox, { fetchSelectedOption } from '../../../UI/PopupListBox/PopupListBox';
import Button from '../../../UI/Button/Button';

// Styled Imports
import formUtilityStyles from '../../BookingForm.module.css';


const { 'form-actions' : formActionsCN, 'wrong-input': wrongInput } = formUtilityStyles;
const MODE_OF_PAYMENT = ['Select One', 'Self', 'Home Loan'];
const AGREE_TO_SOURCE_INFO = ['Select One', 'Agree', 'Disagree']

function BFPage8(props) {
    const errorModalCtx = useContext(ErrorModalContext);

    function handelViewChange(eventOrState){ 
        const viewState = eventOrState?.target?.getAttribute('data-change-state-to') || eventOrState;
        props.changeView(viewState);
    }

    async function formSubmitHandler(event){
        event.preventDefault();

        const modeOfPayment = fetchSelectedOption(event, 'modeOfPayment').selectedValue;
        const paymentType = fetchSelectedOption(event, 'paymentType').selectedValue;
        const agreeToSourceInfo = fetchSelectedOption(event, 'agreeToSourceInfo').selectedValue;

        if( modeOfPayment === 'Select One' ){
            errorModalCtx.showError('Invalid Input!', 'Please select a mode of payment.', ['modeOfPayment']);
            return;
        }

        if( agreeToSourceInfo === 'Select One' ){
            errorModalCtx.showError('Invalid Input!', 'Please select either \'Agree\' or \'Disaagree\' with source info provided above.', ['agreeToSourceInfo']);
            return;
        }

        if( paymentType === 'Select One' ){
            errorModalCtx.showError('Invalid Input!', 'Please select a payment type.', ['paymentType']);
            return;
        }

        errorModalCtx.clearCompErrorList();

        const payLoad = { modeOfPayment, agreeToSourceInfo };

        if(await props.formSubmitHandler(payLoad)) handelViewChange('NEXT')
    }

    return (
        <>
            <form onSubmit={formSubmitHandler}>

                <PopupListBox
                    label='Source List'
                    popupListData={[props.filledValues?.source?.label || 'No Source Selected']}
                    required
                    disabled
                />

                <PopupListBox 
                    label='Sub Source'
                    popupListData={[props.filledValues?.subsource?.label || 'No Sub Source Selected']}
                    disabled
                    required
                /> 

                {
                    props.filledValues.channelpartner !== null && 
                    <PopupListBox 
                        label='Channel Partner'
                        popupListData={[props.filledValues.channelpartner.label]}
                        disabled
                        required
                    /> 
                }

                <PopupListBox 
                    className={`${errorModalCtx.errorFromComp.includes('agreeToSourceInfo')? wrongInput : ''}`}
                    label='Agree to Source Info?'
                    popupListData={AGREE_TO_SOURCE_INFO}
                    name='agreeToSourceInfo'
                    defaultOption={props.filledValues.agreeToSourceInfo}
                    required
                /> 
                
                <PopupListBox
                    className={`${errorModalCtx.errorFromComp.includes('modeOfPayment')? wrongInput : ''}`}
                    label='Mode Of Payment'
                    name='modeOfPayment'
                    popupListData={MODE_OF_PAYMENT}
                    defaultOption={props.filledValues.modeOfPayment}
                    required
                />

                <div className={formActionsCN}>
                    <Button
                        type='button'
                        className='negative'
                        onClick={handelViewChange}
                        dataAttributes={{'data-change-state-to': 'PREVIOUS'}}
                    >
                        <i className="lni lni-angle-double-left" data-change-state-to='PREVIOUS'></i>
                        Previous
                    </Button>
                    <Button
                        type='submit'
                        className='default'
                    >
                        Next
                        <i className="lni lni-angle-double-right" ></i>
                    </Button>
                </div>
            </form>
        </>
    );
}

export default BFPage8;

















// // Functional Imports
// import { useEffect, useReducer, useState } from 'react';

// // Components Import
// import InputBox, { getValueFromInputBoxByName } from '../../../UI/InputBox/InputBox';
// import PopupListBox, { fetchSelectedOption } from '../../../UI/PopupListBox/PopupListBox';
// import Button from '../../../UI/Button/Button';
// import Modal from '../../../UI/ShowModal/ShowModal';
// import AddressInput from '../../../UI/AddressInput/AddressInput';

// // Styled Imports
// import formUtilityStyles from '../../BookingForm.module.css';

// const { 'form-actions' : formActionsCN, 'wrong-input': wrongInput } = formUtilityStyles;


// function errorModalReducer( state, action ){
//     if( action.type === 'NEW_ERROR' ){
//         return { display: true, title: action.title, message: action.message, className: [action.name] };
//     }

//     if( action.type === 'CLOSE_MODAL' ){
//         return { modalDisplay: false, title: '', message: '', className: [...state.className]}
//     }
// }

// function BFPage6(props) {

//     const [ errorState, dispatchErrorState ] = useReducer(
//         errorModalReducer,  { display: false, title: '', message: '', className: [] }
//     );

//     function handelViewChange(event){
//         props.changeView( event.target.getAttribute('data-change-state-to') );
//     }

//     function formSubmitHandler(event){
//         event.preventDefault();
        
//     }

//     function closeModal(){
//         dispatchErrorState({ type: 'CLOSE_MODAL'} );
//     }

//     return (
//         <>
//             <form onSubmit={formSubmitHandler}>
//                 <InputBox 
//                     className={errorState.className.includes('occupation') && wrongInput}
//                     label='Occupation'
//                     type='text' 
//                     name='occupation'
//                     id='occupation'
//                     value={props.filledValues.occupation}
//                     required
//                 />

//                 <InputBox 
//                     className={errorState.className.includes('designation') && wrongInput}
//                     label='Designation'
//                     type='text' 
//                     name='designation'
//                     id='designation'
//                     value={props.filledValues.designation}
//                     required
//                 />

//                 <InputBox 
//                     className={errorState.className.includes('companyName') && wrongInput}
//                     label='Company Name'
//                     type='text' 
//                     name='companyName'
//                     id='company Name'
//                     value={props.filledValues.companyName}
//                     required
//                 />

//                 <InputBox 
//                     className={errorState.className.includes('industry') && wrongInput}
//                     label='Industry'
//                     type='text' 
//                     name='industry'
//                     id='company Name'
//                     value={props.filledValues.industry}
//                     required
//                 />

//                 <div className={formActionsCN}>
//                     <Button
//                         type='button'
//                         className='negative'
//                         onClick={handelViewChange}
//                         dataAttributes={{'data-change-state-to': 'PREVIOUS'}}
//                     >
//                         <i className="lni lni-angle-double-left" data-change-state-to='PREVIOUS'></i>
//                         Previous
//                     </Button>
//                     <Button
//                         type='submit'
//                         className='default'
//                     >
//                         Next
//                         <i className="lni lni-angle-double-right" ></i>
//                     </Button>
//                 </div>
//             </form>
//             {errorState.display && <Modal title={errorState.title} message={errorState.message} closeModal={closeModal}/>}
//         </>
//     );
// }

// export default BFPage6;